// Where the loading plan (who comes when) can come from. Texts live in
// i18n under `sources.<id>.*`; this file only holds the facts per source.
// status: live = works in the demo, demo = simulated, ready = ready to connect.
export const planSources = [
  { id: 'manual', status: 'live', effort: 'low', needsIt: false, pilot: true, link: '/kamiony/import' },
  // Simulated scheduled run, shown as the last automatic import.
  { id: 'sapEmail', status: 'demo', effort: 'medium', needsIt: true, pilot: true, lastRun: { time: '06:00', loadings: 38, errors: 0 } },
  { id: 'folder', status: 'ready', effort: 'medium', needsIt: true },
  { id: 'plannerExcel', status: 'ready', effort: 'medium', needsIt: true },
  { id: 'carrierLink', status: 'ready', effort: 'medium', needsIt: false },
  { id: 'weighbridge', status: 'ready', effort: 'medium', needsIt: true },
  { id: 'sapDirect', status: 'ready', effort: 'high', needsIt: true },
];
